import { StockStatuses } from '../types';

const isOrderableInSecondaryBranch = (
    status?: StockStatuses,
    statuses?: StockStatuses[]
) => {
    if (!status && (statuses?.length ?? 0) === 0) {
        return false;
    }

    return !(
        status === StockStatuses.CANNOT_BE_ORDERED_IN_DESIRED_BRANCH ||
        (statuses &&
            statuses.length === 1 &&
            statuses.find(
                item =>
                    item === StockStatuses.CANNOT_BE_ORDERED_IN_DESIRED_BRANCH
            ))
    );
};

export default isOrderableInSecondaryBranch;
